import ApiService from '../../services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'SettingsThemeDomains',
  props: {
    domains: {
      type: Array,
      default: () => [],
      required: true
    },
    tenantId: {
      type: Number,
      default: -1,
      required: true
    }
  },
  data() {
    return {
      errorMessage: '',
      domainInput: '',
      isDomainCheckBusy: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  },
  methods: {
    clearError() {
      this.errorMessage = '';
    },
    isValidDomain(domain) {
      const ipTest = /^(?:(?:http[s]?)?:\/\/)?([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})\.([1-9]{1}[0-9]{0,2})$/;
      if (ipTest.test(domain)) {
        // make sure it is a valid IPv4 address
        return domain.match(ipTest).slice(1).every(n => parseInt(n) >= 0 && parseInt(n) <= 255);
      }
      const domainTest = /^((http(s?))?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-.]{1,62}(?:\.[a-zA-Z]{2,})+$/;
      return domainTest.test(domain.toLowerCase());
    },
    getDomainFromUrl(domain) {
      const cleanDomain = domain.toLowerCase().trim().replace(/^(?:(?:http[s]?)?:\/\/)?/i, '').split(/\/+/).slice(0, 1).join('');
      return this.isValidDomain(cleanDomain) ? cleanDomain : null;
    },
    isAvailableDomain(domain) {
      return ApiService.getTheming(domain).then(result => {
        const lowercaseDomain = (domain || '').toLowerCase();
        const protocollessDomain = lowercaseDomain.replace(/^http(s?):\/\//g, '');
        return get(result, 'theme.tenantId') === undefined || parseInt(get(result, 'theme.tenantId') === this.tenantId) ||
        // NOTE: the themeing-fetch has a fallback to look up the hierarchy if neither for the tenant nor the domain
        // a theming was found. So check for the returned theme that it does not contain the domain yet,
        // IF it belongs to another tenant (aka the check just above)
        (get(result, 'theme.domains') || []).indexOf(protocollessDomain) < 0;
      });
    },
    addDomain() {
      // change domain to lowercase and remove anything that follows the actual domain
      // like "/#/system-settings" in "http://ui.127.0.0.1.xip.io/#/system-settings"
      const domain = this.getDomainFromUrl(this.domainInput);
      if (!domain) {
        // Sanitized Input is empty - Invalid Domain
        this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainInvalid', {
          domain: this.domainInput
        });
        return;
      } else if (this.domains.includes(domain)) {
        // Domain already exists in this list on the current tenant
        this.domainInput = domain;
        this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainDuplicate', {
          domain: domain
        });
        return;
      }
      this.isDomainCheckBusy = true;
      this.isAvailableDomain(domain).then(isThemeAvailable => {
        if (!isThemeAvailable) {
          // Domain is used in another tenant
          this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainExists', {
            domain: domain
          });
        } else {
          this.domains.push(domain);
          this.domainInput = '';
          this.$emit('update', this.domains);
        }
      }).catch(error => {
        console.error(error.name === 'EXISTS');
        this.errorMessage = this.$i18n_t('accMgmt.tenant.errorDomainUnknown', {
          domain: domain
        });
      }).finally(() => {
        this.isDomainCheckBusy = false;
      });
    },
    deleteDomain(domain) {
      const cleanDomains = this.domains.filter(item => item !== domain);
      this.$emit('update', cleanDomains);
    }
  }
};